var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getMsalApp } from '../auth/msalApp';
import axios from 'axios';
import moment from 'moment';
export function createMeetingService() {
    return {
        createMeeting(meeting) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return __awaiter(this, void 0, void 0, function* () {
                let token;
                const msalApp = yield getMsalApp();
                try {
                    token = yield msalApp.acquireTokenSilent({
                        scopes: ['OnlineMeetings.ReadWrite']
                    });
                }
                catch (ex) {
                    token = yield msalApp.acquireTokenPopup({
                        scopes: ['OnlineMeetings.ReadWrite']
                    });
                }
                const requestBody = {
                    startDateTime: (_a = meeting.startDateTime) === null || _a === void 0 ? void 0 : _a.toISOString(),
                    endDateTime: (_b = meeting.endDateTime) === null || _b === void 0 ? void 0 : _b.toISOString(),
                    subject: meeting.subject
                };
                const response = yield axios.post('https://graph.microsoft.com/beta/me/onlineMeetings', requestBody, {
                    headers: {
                        Authorization: `Bearer ${token.accessToken}`,
                        'Content-type': 'application/json'
                    }
                });
                const preview = decodeURIComponent(((_e = (_d = (_c = response.data.joinInformation.content) === null || _c === void 0 ? void 0 : _c.split(',')) === null || _d === void 0 ? void 0 : _d[1]) !== null && _e !== void 0 ? _e : '').replace(/\+/g, '%20'));
                const createdMeeting = {
                    id: response.data.id,
                    creationDateTime: moment(response.data.creationDateTime),
                    subject: response.data.subject,
                    joinUrl: response.data.joinUrl,
                    joinWebUrl: response.data.joinWebUrl,
                    startDateTime: moment(response.data.startDateTime),
                    endDateTime: moment(response.data.endDateTime),
                    conferenceId: ((_f = response.data.audioConferencing) === null || _f === void 0 ? void 0 : _f.conferenceId) || '',
                    tollNumber: ((_g = response.data.audioConferencing) === null || _g === void 0 ? void 0 : _g.tollNumber) || '',
                    tollFreeNumber: ((_h = response.data.audioConferencing) === null || _h === void 0 ? void 0 : _h.tollFreeNumber) || '',
                    dialinUrl: ((_j = response.data.audioConferencing) === null || _j === void 0 ? void 0 : _j.dialinUrl) || '',
                    videoTeleconferenceId: response.data.videoTeleconferenceId,
                    preview
                };
                return createdMeeting;
            });
        }
    };
}
